import { Box, Button, Divider, FormControl, Grid, TextareaAutosize, Typography} from "@mui/material";
import { IAddCommentProps } from "../types/interfaces/IAddCommentProps";
import { ChangeEvent, useState } from "react";

//This component is responsible for adding a new plan comment. 
const AddComment: React.FC<IAddCommentProps> = ({ onCommentSave }) =>  {
    const [text, setText] = useState('');
    const maxLength = 6000;
    const placeholderText = `${maxLength} Character Limit`;
    let remainingChars = maxLength;
    
    if (text !== null && text.length > 0) {
        remainingChars = maxLength - text.length;
    }

    //Function to handle the comment change.
    const handleCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setText(e.target.value.slice(0, maxLength));
    }

    //Function to handle the comment save.
    const handleCommentSave = async () => {       
        onCommentSave(text);
        setText('');
    };

    return (
        <>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold'}}>Add Comment</Box>
            </Typography>
            <Typography variant="body1" component="div" sx={{mt:1, mb:1, width: "60%", minWidth: 255 }}>
                Comments are visible to the learner the next time they access their plan after the comment is saved.
            </Typography>
            <FormControl sx={{ m: 1, width: "60%", minWidth: 255 }}>
                <TextareaAutosize
                    id="comment"
                    minRows={3}
                    placeholder={placeholderText}
                    maxLength={maxLength}
                    value={text || ''}
                    onChange={(e) => handleCommentChange(e)} />
                <Typography variant="body2" align="right">
                    {remainingChars} characters left
                </Typography>
            </FormControl>
            <Box sx={{mt:1}}>
                <FormControl sx={{ paddingBottom: 5 }}>
                    <Grid container spacing={1}>
                        <Grid item>
                            <Button
                                onClick={handleCommentSave}
                                disabled={!text}
                                variant="contained"
                                size="large"
                                sx={{ maxWidth: 300, fontSize:24 }} >
                                Save Comment
                            </Button>
                        </Grid>
                    </Grid>
                </ FormControl>
            </Box>
            <Divider sx={{mt:1, mb:5}}></Divider>
        </>
    );
}

export default AddComment;